<template>
  <div class="page">
    <div class="banner">
      <img :src="bannerImg">
      <div class="title">人才招募</div>
    </div>
    <div class="page-bd" v-loading.fullscreen.lock="fullscreenLoading">
      <div class="recruit" v-for="item in tableData">
        <div class="recruit-hd">
          <div class="recruit-title">
            职位名称：{{item.name}}
          </div>
          <div class="recruit-titleTag" v-if="item.status == 1">正在招募</div>
          <div class="recruit-titleTag-stop" v-if="item.status != 1">暂停招募</div>
        </div>
        <div class="recruit-title">主要职责：</div>
        <div class="recruit-desc">
          {{item.duty}}
        </div>

        <div class="recruit-title">职位要求：</div>
        <div class="recruit-desc">
          {{item.content}}
        </div>
        <div class="recruit-title">薪资待遇：</div>
        <div class="recruit-desc">
          {{item.salary}}
        </div>
      </div>

      <div class="recruit">
        <div class="recruit-title">联系方式：</div>
        <div class="recruit-desc">
          <el-row type="flex">
            <el-row class="contact-item" type="flex" align="middle">
              <img src="~@/assets/images/icon-email-y.png" class="recruit-icon">
              <span>邮箱：{{tableData[0].email}}</span>
            </el-row>
            <el-row class="contact-item" type="flex" align="middle">
              <img src="~@/assets/images/icon-phone-y.png" class="recruit-icon">
              <span>电话：{{tableData[0].mobile}}</span>
            </el-row>
            <el-row class="contact-item" type="flex" align="middle">
              <img src="~@/assets/images/icon-wechat-y.png" class="recruit-icon">
              <span>微信：{{tableData[0].wechat}}</span>
            </el-row>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { request } from "@/util/request"

export default {
  name: "evaluationDetail",
  data () {
    return {
      fullscreenLoading: false,
      bannerImg: '',
      tableData:[]
    }
  },
  methods: {
    getBanner () {
      this.fullscreenLoading = true
      request({
        method: 'get',
        url: '/index/getBanner',
        params: {
          type: 6
        }
      }).then(res => {
        this.fullscreenLoading = false
        if (![0, 200].includes(res.code)) {
          return this.$message.error(res.msg)
        }
        if (res.data[0]) {
          this.bannerImg = res.data[0].image
        }
      }).catch((res) => {
      });
    },
    getRecruitInfo () {
      this.fullscreenLoading = true
      request({
        method: 'get',
        url: '/recruitInfo/list',
      }).then(res => {
        this.tableData = res.data
      }).catch((res) => {
      });
    },
  },
  created () {
    this.getBanner();
    this.getRecruitInfo();
  }
}
</script>

<style scoped lang="stylus">
.page
  font-size 15px
  background #F9F9F9
  width 100%
  .banner
    position: relative;
    width: 100%;
    height: 260px;
    img
      display: block;
      width: 100%;
      height: 100%;
      -o-object-fit: cover;
      object-fit: cover;
    .title
      position: absolute;
      top: 50%;
      left: 50%;
      margin-top: -43px;
      margin-left: -100px;
      z-index: 1;
      width: 200px;
      height: 86px;
      font-size: 50px;
      //font-weight: PingFangMedium600;
      color: #FFFFFF;
      line-height: 86px;
      text-shadow: 0 4px 4px rgba(121,68,2,0.1);
  &-bd
    width 1440px
    margin 10px auto 60px auto
    // uiBlock()
    // padding 32px 22px 39px 22px
    box-sizing border-box

.recruit
  line-height: 40px;
  padding 12px 22px 12px 22px
  background: #fff;
  border-radius: 6px;
  margin-bottom: 10px;
  &-icon
    width: 40px;
    height: 40px;
    vertical-align: top;
    margin-right: 5px;
  &-hd
    display flex
    justify-content space-between
    padding-bottom: 10px;
  &-title
    font-size 18px
    font-weight 600
    // margin-bottom 30px
  &-titleTag
    color #fff
    font-size 18px
    //background: linear-gradient(90deg, #007001, #009501)
    background: #fc6621
    align-self: start;
    padding: 6px 12px
    border-radius 4px
    font-weight: 600;
    line-height: initial;
  &-titleTag-stop
    color #fff
    font-size 18px
    background: linear-gradient(90deg, #808080, #808080)
    align-self: start;
    padding: 6px 12px
    border-radius 4px
    font-weight: 600;
    line-height: initial;

  &-desc
    font-size 16px;
    white-space: pre-line;


.contact-item + .contact-item
  margin-left: 50px;
</style>
